import { format, parseISO } from "date-fns"
import { DATETIME_DISPLAY_FORMAT } from "./config";

const displayDateTime = arg => {
  const date = typeof arg === 'string' ? parseISO(arg) : arg;
  return format(date, DATETIME_DISPLAY_FORMAT);  
}

export default displayDateTime;
